import { z } from 'zod';

import { LOCATION_TYPE } from '~/constants/vCard';
import { zTemplate } from '~/utils/validation';
import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';

export const DEFAULT_VALUES = {
  location: {
    type: LOCATION_TYPE.FULL,
  },
};

export const getSchema = ({ t }) =>
  z
    .object({
      firstName: z
        .string({ message: t('inputs:required') })
        .trim()
        .min(1, t('inputs:required'))
        .max(70, t('errors:max', { count: 70 })),
      lastName: z
        .string()
        .max(70, t('errors:max', { count: 70 }))
        .optional(),
      organization: z.string().optional(),
      website: z
        .string()
        .url({ message: t('errors:url_2') })
        .max(500, t('errors:max', { count: 500 }))
        .optional(),
      email: z
        .string()
        .max(254, t('errors:max', { count: 254 }))
        .email(t('errors:emailIsValid'))
        .optional()
        .or(zTemplate.emptyString().optional()),
      companyName: z
        .string()
        .max(50, { message: t('errors:max', { count: 50 }) })
        .optional(),
      companyPosition: z.string().optional(),
      phones: z
        .array(
          z.object({
            type: z.string(),
            phone: z
              .string({ message: t('inputs:required') })
              .trim()
              .min(1, t('inputs:required'))
              .max(40, t('errors:max', { count: 40 })),
          }),
        )
        .optional(),
      location: z.object({
        type: z.enum(Object.values(LOCATION_TYPE)),
        street: z.string().optional(),
        postalCode: z.string().optional(),
        number: z.string().optional(),
        city: z.string().optional(),
        state: z.string().optional(),
        country: z.string().optional(),
        url: z
          .string()
          .url({ t })
          .max(500, { message: t('errors:max', { count: 500 }) })
          .optional(),
        latitude: z.string().optional(),
        longitude: z.string().optional(),
      }),
    })
    .merge(getGeneralStaticBuilderSchema());
